import { faCheck, faX } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { type CellContext } from '@tanstack/react-table';

export function CellBoolean<TData, TValue>({ getValue }: CellContext<TData, TValue>) {
    const value = getValue();
    return (
        <div className="flex flex-1 items-center justify-center text-lg">
            <FontAwesomeIcon icon={value ? faCheck : faX} />
        </div>
    );
}
